import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { IconImage, TextCaption3, Spinner } from '@blocket/blocket-ui'
import { imageLoad } from 'utils/image'
import { ImgPlaceholder, ChatImage, ImgTextWrapper, ImageSpinnerWrapper } from '../../../style.js'

const Image = ({ msg, isMe, recipientName, onImageClick = () => {} }) => {
  const { type, url, thumbnails } = msg
  const [imageSrc, setImageSrc] = useState('')
  const [isLoading, setIsLoading] = useState()

  const aspectRatio = (get(thumbnails, '[0].realHeight') / get(thumbnails, '[0].realWidth')) * 100
  const isGif = type === 'image/gif'
  const imgUrl = !isGif && thumbnails ? get(thumbnails, '[0].url') : url

  useEffect(() => {
    setIsLoading(true)

    imageLoad({
      src: imgUrl,
      onLoad: () => {
        setImageSrc(imgUrl)
        setIsLoading(false)
      },
    })
  }, [imgUrl])

  return (
    <>
      <ImgPlaceholder
        aspectRatio={aspectRatio}
        isMe={isMe}
        onClick={() => {
          onImageClick({ url })
        }}
      >
        {isLoading && (
          <ImageSpinnerWrapper>
            <Spinner />
          </ImageSpinnerWrapper>
        )}
        <ChatImage src={imageSrc} alt="" />
      </ImgPlaceholder>
      {!isMe && (
        <ImgTextWrapper data-testid="image-text">
          <IconImage color="#363433" width={16} height={16} style={{ marginRight: 4 }} />
          <TextCaption3 style={{ lineHeight: 'normal' }}>
            Bild skickad från {recipientName}
          </TextCaption3>
        </ImgTextWrapper>
      )}
    </>
  )
}

Image.propTypes = {
  msg: PropTypes.object.isRequired,
  isMe: PropTypes.bool.isRequired,
  recipientName: PropTypes.string.isRequired,
}

export default Image
